export default __webpack_public_path__ + "static/media/binance.us.bf616afe.svg";